export default __webpack_public_path__ + "static/media/img-login-680w.3751921b.jpg";